/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */
import { IDomainModel } from './domain-model.interface';

import { DepositAccounts } from './deposit-account.domain';
import { DocumentTypes } from './document-type.domain';
import { MimeTypes } from './mime-type.domain';
import { PropertyTypes } from './property-type.domain';
import { PropertyWorkflowActions } from './property-workflow-action.domain';
import { StateProvinces } from './state-province.domain';
import { TransactionTypes } from './transaction-type.domain';
import { DocumentTypeRelevanceTransactionTypeMappings } from './document-type-relevance-transaction-type-mapping.domain';
export * from './deposit-account.domain';
export * from './document-type.domain';
export * from './mime-type.domain';
export * from './property-type.domain';
export * from './property-workflow-action.domain';
export * from './state-province.domain';
export * from './transaction-type.domain';
export * from './document-type-relevance-transaction-type-mapping.domain';

export const Lookups: IDomainModel[][] = new Array<IDomainModel[]>(
   DepositAccounts,
   DocumentTypes,
   MimeTypes,
   PropertyTypes,
   PropertyWorkflowActions,
   StateProvinces,
   TransactionTypes,
   DocumentTypeRelevanceTransactionTypeMappings,
);
